import script from "./LanguageMode.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageMode.vue?vue&type=script&setup=true&lang=js"

import "./LanguageMode.vue?vue&type=style&index=0&id=6221a0bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6221a0bc"]])

export default __exports__